import { useAppSelector } from '@app/store/store';
import React, { useCallback } from 'react';

import { AspectRatioDropdown } from '../../../../components/aspect-ratio-dropdown';
import type { AdvancedEditAspectRatio } from '../../../../domain';
import { useRecordingAnalytics } from '../../../../hooks';
import { selectActiveEditAspectRatio } from '../../../../selector';
import { useEditDraftUpdate } from './components/edit-appearance-panel/use-edit-draft-update';

export const EditAspectRatioDropdown = () => {
  const { trackRecordingEvent } = useRecordingAnalytics();
  const { currentDraft, updateDraft } = useEditDraftUpdate();
  const aspectRatio = useAppSelector(selectActiveEditAspectRatio);

  const handleAspectRatioChange = useCallback(
    (value: '16_9' | '9_16') => {
      trackRecordingEvent('ch_creator_lab_aspect_ratio_changed', {
        aspect_ratio: value,
      });
      updateDraft(draft => ({
        ...draft,
        aspectRatio: value as AdvancedEditAspectRatio,
      }));
    },
    [trackRecordingEvent, updateDraft],
  );

  if (!currentDraft) {
    return null;
  }

  const dropdownValue =
    aspectRatio === '9_16' || aspectRatio === '16_9' ? aspectRatio : '16_9';

  return (
    <AspectRatioDropdown
      value={dropdownValue}
      onChange={handleAspectRatioChange}
    />
  );
};
